// ----------------------------------------------------------------------------
// Snippet: Smart Cart Template
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_smart-cart-template.scss';

//Adds "Last Chance Disclaimer" to products in SmartCart with Tags "last-chance" and "exchange-only".
function addLastChanceDisclaimer() {
    $('.rebuy__cart__line-item').each(function(index, value) {
        var itemDisclaimer = $(this).find('.rebuy-cart__last-chance_disclaimer');
        itemDisclaimer.html('');
        itemDisclaimer.addClass('hidden');

        if ($(this).attr('data-tags').includes("finalsale")) {
            itemDisclaimer.html("<span> This item is final sale</span>");
            itemDisclaimer.removeClass('hidden');
        } else if ($(this).attr('data-tags').includes("exchange-only") || $(this).attr('data-tags').includes("last-chance")) {
            itemDisclaimer.html("<span> This item is only eligible for exchange or store-credit</span>");
            itemDisclaimer.removeClass('hidden');
    }
    });
}

// ========================================================================
// Rebuy GWP Error Suppression - Setup Function
// ========================================================================
function setupGWPErrorSuppression() {
    if (window.Rebuy && window.Rebuy.SmartCart) {
        console.log('[Rebuy GWP] Setting up error suppression for GWP operations');

        // Store original handlers
        const originalOnError = window.Rebuy.SmartCart.onError;
        const originalShowError = window.Rebuy.SmartCart.showError;
        const originalShowNotification = window.Rebuy.SmartCart.showNotification;

        // Override error handler to filter out GWP-related errors
        window.Rebuy.SmartCart.onError = function(error) {
            console.log('[Rebuy GWP] Error intercepted:', error);

            try {
                // Check if error is related to GWP operations or gift removal
                const errorMessage = error?.message || error?.description || error?.error || String(error);
                const isGWPError = errorMessage.includes('updates parameter') ||
                                   errorMessage.includes('invalid') ||
                                   errorMessage.includes('Unprocessable') ||
                                   errorMessage.includes('422') ||
                                   errorMessage.includes('_widget_id') ||
                                   errorMessage.includes('Gift') ||
                                   errorMessage.toLowerCase().includes('gift');

                if (isGWPError) {
                    console.log('[Rebuy GWP] ✅ Suppressed GWP-related error:', errorMessage);
                    // Don't show error to user - this is expected during GWP operations
                    return false;
                }

                console.log('[Rebuy GWP] ⚠️ Non-GWP error, passing through:', errorMessage);
            } catch (e) {
                console.warn('[Rebuy GWP] Error checking error message:', e);
            }

            // For non-GWP errors, call original handler if it exists
            if (originalOnError && typeof originalOnError === 'function') {
                return originalOnError.call(this, error);
            } else {
                console.error('[Rebuy SmartCart] Error:', error);
            }
        };

        // Also override showError if it exists
        if (window.Rebuy.SmartCart.showError) {
            window.Rebuy.SmartCart.showError = function(error) {
                console.log('[Rebuy GWP] showError called:', error);

                try {
                    const errorMessage = typeof error === 'string' ? error : (error?.message || error?.description || String(error));
                    const isGWPError = errorMessage.includes('updates parameter') ||
                                       errorMessage.includes('invalid') ||
                                       errorMessage.includes('Unprocessable') ||
                                       errorMessage.includes('422') ||
                                       errorMessage.includes('_widget_id') ||
                                       errorMessage.includes('Gift') ||
                                       errorMessage.toLowerCase().includes('gift');

                    if (isGWPError) {
                        console.log('[Rebuy GWP] ✅ Suppressed error display:', errorMessage);
                        return false;
                    }
                } catch (e) {
                    console.warn('[Rebuy GWP] Error checking showError message:', e);
                }

                // Show non-GWP errors normally
                if (originalShowError && typeof originalShowError === 'function') {
                    return originalShowError.call(this, error);
                }
            };
        }

        // Override showNotification to suppress GWP-related notifications/toasts
        if (window.Rebuy.SmartCart.showNotification) {
            window.Rebuy.SmartCart.showNotification = function(message, type) {
                console.log('[Rebuy GWP] showNotification called:', message, type);

                try {
                    const notificationMessage = typeof message === 'string' ? message : (message?.message || String(message));
                    const isGWPNotification = notificationMessage.includes('updates parameter') ||
                                              notificationMessage.includes('invalid') ||
                                              notificationMessage.includes('Unprocessable') ||
                                              notificationMessage.includes('422') ||
                                              notificationMessage.toLowerCase().includes('gift');

                    if (isGWPNotification || type === 'error') {
                        console.log('[Rebuy GWP] ✅ Suppressed notification:', notificationMessage);
                        return false;
                    }
                } catch (e) {
                    console.warn('[Rebuy GWP] Error checking notification:', e);
                }

                // Show non-GWP notifications normally
                if (originalShowNotification && typeof originalShowNotification === 'function') {
                    return originalShowNotification.call(this, message, type);
                }
            };
        }

        console.log('[Rebuy GWP] ✅ Error suppression installed');
        return true;
    }
    return false;
}

$(function() {

    console.log('[Rebuy SmartCart] Initializing...');

    // ========================================================================
    // Rebuy GWP Error Suppression - Initialize IMMEDIATELY
    // ========================================================================
    // Try to set up error suppression as soon as possible
    if (!setupGWPErrorSuppression()) {
        // If Rebuy isn't ready yet, poll for it
        console.log('[Rebuy GWP] Waiting for Rebuy to load...');
        const checkInterval = setInterval(function() {
            if (setupGWPErrorSuppression()) {
                clearInterval(checkInterval);
            }
        }, 100);
        
        // Stop checking after 10 seconds
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 10000);
    }

    document.addEventListener('rebuy:smartcart.ready', function(event){
        console.log('[Rebuy SmartCart] SmartCart ready event fired');

        const util = window.Rebuy.util;
        util.wait(addLastChanceDisclaimer, 300);

        // Ensure error suppression is set up (in case it wasn't before)
        setupGWPErrorSuppression();

        //This event is triggered whenever SmartCart slider is opened or updated.
        document.addEventListener('rebuy:cart.change', function(event){
            console.log('[Rebuy SmartCart] Cart change event fired');

            // Update MiniCart when product is added via Rebuy SmartCart
            Shopify.miniCart.init();
            util.wait(addLastChanceDisclaimer, 300);
        });
  });

  // ========================================================================
  // Monitor Rebuy cart operations for debugging
  // ========================================================================

  document.addEventListener('rebuy:cart.before_change', function(event) {
      console.log('[Rebuy GWP] Before cart change:', event.detail);
  });

  document.addEventListener('rebuy:product.add', function(event) {
      console.log('[Rebuy GWP] Product add event:', event.detail);
  });

  document.addEventListener('rebuy:product.remove', function(event) {
      console.log('[Rebuy GWP] Product remove event:', event.detail);
  });

  // ========================================================================
  // Fetch API Interceptor - Suppress GWP 422 errors in console
  // ========================================================================
  // Wrap native fetch to silence 422 errors from Rebuy GWP operations
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
      const [url, options] = args;
      
      return originalFetch.apply(this, args).then(response => {
          // Check if this is a cart update that failed with 422
          if (response.status === 422 && typeof url === 'string' && url.includes('/cart/update.js')) {
              console.log('[Rebuy GWP] ✅ Intercepted 422 error from cart/update.js - likely GWP operation');
              
              // Clone response to read body without consuming it
              const clonedResponse = response.clone();
              clonedResponse.json().then(data => {
                  const errorMsg = data?.description || data?.message || '';
                  if (errorMsg.includes('updates parameter') || errorMsg.includes('invalid')) {
                      console.log('[Rebuy GWP] ✅ Confirmed GWP error, suppressing:', errorMsg);
                  }
              }).catch(() => {});
              
              // Still return the response for Rebuy to handle
              return response;
          }
          
          return response;
      }).catch(error => {
          // Check if error is GWP-related
          const errorMessage = error?.message || String(error);
          if (errorMessage.includes('updates parameter') || 
              errorMessage.includes('422') ||
              errorMessage.includes('cart/update')) {
              console.log('[Rebuy GWP] ✅ Fetch error suppressed:', errorMessage);
              throw error; // Re-throw but it's been logged nicely
          }
          throw error;
      });
  };
  console.log('[Rebuy GWP] ✅ Fetch interceptor installed');

  // ========================================================================
  // Global error suppression for GWP-related errors
  // ========================================================================
  // Catch any GWP errors that slip through Rebuy's handlers

  window.addEventListener('error', function(event) {
      const errorMessage = event?.message || event?.error?.message || String(event);

      // Check if this is a GWP-related error
      if (errorMessage.includes('updates parameter') ||
          errorMessage.includes('invalid') ||
          errorMessage.includes('Unprocessable') ||
          errorMessage.includes('422') ||
          errorMessage.toLowerCase().includes('gift')) {
          console.log('[Rebuy GWP] ✅ Global error suppression - prevented:', errorMessage);
          event.preventDefault();
          event.stopPropagation();
          return false;
      }
  }, true);

  // Hide error notifications via CSS as an additional safety net
  const style = document.createElement('style');
  style.id = 'rebuy-gwp-error-suppression';
  style.textContent = `
    /* Hide Rebuy error notifications for GWP operations */
    .rebuy-notification.rebuy-notification--error,
    .rebuy-toast--error,
    .rebuy-error-message {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  console.log('[Rebuy GWP] ✅ CSS error suppression added');

  // Also suppress unhandled promise rejections related to GWP
  window.addEventListener('unhandledrejection', function(event) {
      const errorMessage = event?.reason?.message || String(event.reason);

      if (errorMessage.includes('updates parameter') ||
          errorMessage.includes('invalid') ||
          errorMessage.includes('Unprocessable') ||
          errorMessage.includes('422') ||
          errorMessage.toLowerCase().includes('gift')) {
          console.log('[Rebuy GWP] ✅ Suppressed promise rejection:', errorMessage);
          event.preventDefault();
          return false;
      }
  });

  console.log('[Rebuy GWP] ✅ Global error handlers installed');

});
